module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-180x180-5c898a5f333cd0abe16cbe2f260b797e.png";